import { TForm } from '@pages/ContactSales/types/TForm';

export const isContactSalesFormIncomplete = (formState: TForm) =>
  (!formState.interested.asone &&
    !formState.interested.asWeb &&
    !formState.interested.attorney &&
    !formState.interested.notSure) ||
  !formState.details.name ||
  !formState.details.surname ||
  !formState.details.email ||
  !formState.details.phone ||
  !formState.typeOfWork ||
  !formState.role ||
  !formState.outsource;
